export default {
    en: {
        whatsYourName: 'What\'s your name?',
        writeMessage: 'Write message',
        howShouldWeCallYou: 'How should we call you?',
        sharingArtworks: 'Sharing artworks',
        whatAreYouInterestedIn: 'Hello, {name}!&& What are you interested in?',
        followingArtists: 'Following Artists',
        joiningCreatillo: 'Joining Creatillo',
        sharePortfolio: 'Could you share a social link or portfolio?&& It\'s not mandatory, but highly recommended to let us know you better.',
        whyAreYouMotivated: 'Awesome! Why are you motivated in joining the team?&& What are your expectations?',
        provideAnswer: 'Provide an answer!',
        thatsGreat: 'That\'s great!',
        checkEmailFormat: 'Double check your email format!',
        oneLastThing: 'One last thing. What\'s your email?',
        thanksForJoining: 'Thanks for joining the waitlist! We\'ll get back to you.'
    },
    hu: {
        whatsYourName: 'Hogy hívnak?',
        writeMessage: 'Üzenet írása',
        howShouldWeCallYou: 'Hogyan szólítsunk?',
        sharingArtworks: 'Alkotások megosztása',
        whatAreYouInterestedIn: 'Szia, {name}!&& Mi érdekel téged?',
        followingArtists: 'Alkotók követése',
        joiningCreatillo: 'Csatlkozás a Creatillohoz',
        sharePortfolio: 'Meg tudod osztani velünk egy közösségi oldaladat, vagy a portfóliódat?&& Ez nem kötelező, de ajánlott, hogy jobban megismerjünk.',
        whyAreYouMotivated: 'Szuper! Mi motivál, hogy csatlakozz a csapathoz?&& Mik az elképzeléseid?',
        provideAnswer: 'Válaszold meg a kérdést!',
        thatsGreat: 'Nagyszerű!',
        checkEmailFormat: 'Ellenőrizd az emailed formátumát!',
        oneLastThing: 'Egy utolsó kérdés. Mi az email címed?',
        thanksForJoining: 'Köszönjük, hogy feliratkoztál a várólistára! Fel fogjuk venni veled a kapcsolatot.'
    }
}